module.exports = __webpack_public_path__ + "img/boletos-banner.3633ce33.jpg";